'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var getEnv = require('./get-env.js');
require('lodash/get');
require('lodash/omitBy');
require('lodash/isEmpty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var bootIntercom = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(data) {
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", window.Intercom('boot', _objectSpread({}, data, {
              app_id: getEnv["default"].INTERCOM_APP_ID,
              // eslint-disable-line camelcase
              user_hash: data.intercomHash
            })));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function bootIntercom(_x) {
    return _ref.apply(this, arguments);
  };
}();
var showNewMessage = function showNewMessage(message) {
  return (// @ts-expect-error TS(2339): Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message
    window.Intercom('showNewMessage', typeof message === 'string' ? message : '')
  );
}; // eslint-disable-line new-cap
// @ts-expect-error TS(2339): Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message

var shutdownIntercom = function shutdownIntercom() {
  return window.Intercom('shutdown');
}; // eslint-disable-line new-cap
// @ts-expect-error TS(2339): Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message

var trackEvent = function trackEvent(name, data) {
  return window.Intercom('trackEvent', name, data);
}; // eslint-disable-line new-cap
// @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateDVAInvoice = function trackCreateDVAInvoice(data) {
  return trackEvent('created-dva-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateHICAPSInvoice = function trackCreateHICAPSInvoice(data) {
  return trackEvent('created-hicaps-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateMedicareInvoice = function trackCreateMedicareInvoice(data) {
  return trackEvent('created-medicare-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreatePatientFundedInvoice = function trackCreatePatientFundedInvoice(data) {
  return trackEvent('created-patient-funded-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateNDISInvoice = function trackCreateNDISInvoice(data) {
  return trackEvent('created-ndis-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateOHCInvoice = function trackCreateOHCInvoice(data) {
  return trackEvent('created-ohc-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateVirtualTerminalInvoice = function trackCreateVirtualTerminalInvoice(data) {
  return trackEvent('created-virtual-terminal-invoice', data);
}; // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.

var trackCreateQuote = function trackCreateQuote(data) {
  return trackEvent('created-quote', data);
}; // @ts-expect-error TS(2339): Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message

var updateIntercom = function updateIntercom(data) {
  return window.Intercom('update', data);
}; // eslint-disable-line new-cap

var intercom = {};

exports.bootIntercom = bootIntercom;
exports["default"] = intercom;
exports.showNewMessage = showNewMessage;
exports.shutdownIntercom = shutdownIntercom;
exports.trackCreateDVAInvoice = trackCreateDVAInvoice;
exports.trackCreateHICAPSInvoice = trackCreateHICAPSInvoice;
exports.trackCreateMedicareInvoice = trackCreateMedicareInvoice;
exports.trackCreateNDISInvoice = trackCreateNDISInvoice;
exports.trackCreateOHCInvoice = trackCreateOHCInvoice;
exports.trackCreatePatientFundedInvoice = trackCreatePatientFundedInvoice;
exports.trackCreateQuote = trackCreateQuote;
exports.trackCreateVirtualTerminalInvoice = trackCreateVirtualTerminalInvoice;
exports.trackEvent = trackEvent;
exports.updateIntercom = updateIntercom;
